import {
  CORP_TO_CORP,
  EMPLOYEE_NO_BENEFITS,
  EMPLOYEE_WITH_BENEFITS,
  INDEPENDENT_CONTRACTOR
} from '@/lib/constants/employeeTypes'

export function getOverheadPercent (employeeType, overheadPercents) {
  let overheadPercentage
  switch (employeeType) {
    case INDEPENDENT_CONTRACTOR:
      overheadPercentage = overheadPercents.overheadPercentage1099
      break
    case CORP_TO_CORP:
      overheadPercentage = overheadPercents.overheadPercentageC2C
      break
    case EMPLOYEE_NO_BENEFITS:
      overheadPercentage = overheadPercents.overheadPercentageW2NoBenefits
      break
    case EMPLOYEE_WITH_BENEFITS:
      overheadPercentage = overheadPercents.overheadPercentageW2Benefits
      break
    default:
      overheadPercentage = 0
      break
  }
  return overheadPercentage
}
